export const projecManagerResponsibilitiesData = [
  {
    text: "Analyzing customers’ needs",
  },
  {
    text: "Preparing price quotes",
  },
  {
    text: "Assigning translators",
  },
  {
    text: "Performing quality checks",
  },
  {
    text: "Delivering translations to clients",
  },
  {
    text: "Monitoring and controlling projects status",
  },
  {
    text: "Serving clients and translators via email, chat and phone",
  },
  {
    text: "Handling complaints",
  },
  {
    text: "Reporting to team leaders and COO",
  },
];

export const freelanceQualificationsData = [
  {
    text: "Fluency in two or more languages",
  },
  {
    text: "At least three years of translation experience",
  },
  {
    text: "Excellent writing skills and command of grammar",
  },
  {
    text: "Passion for writing",
  },
  {
    text: "At least three years of translation experience",
  },
  {
    text: "Academic degree (an advantage)",
  },
  {
    text: "Experience with CAT tools",
  },
  {
    text: "Professional expertise in one of the following fields: legal, technical, IT, medical, financial or marketing",
  },
  {
    text: "Attention to detail combined with the ability and availability to meet tight deadlines",
  },
];
